var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('list-item',{attrs:{"name":_vm.name,"description":_vm.formatedTime},on:{"edit-item":_vm.goToItem,"delete-item":_vm.deleteItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }